<template>
<div class="logContainer">
  <div class="mainContent" :style="styleObject">
    <div class="logHandlerArea handlerArea">
        <el-select class="selectForm" v-model="logType" placeholder="请选择日志类型" clearable>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <!-- <el-date-picker class="dateTimeRangePicker" v-model="dateTimeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker> -->
         <el-input class="scontent" placeholder="请输入操作内容" v-model="content" style="width:170px;"></el-input>
         <el-input class="scontent" placeholder="请输入操作IP地址" v-model="ip" style="width:170px;"></el-input>
         <button v-if="rolePermit('log:query')" class="primaryBtn" @click="searchLogs">搜索</button>
        <el-button v-if="rolePermit('log:del')" class="delSome" type="danger" plain icon="el-icon-delete" @click="delLogs">清空一个月前记录</el-button>
    </div>
    <div class="logContentShowArea" v-loading="loading">
      <div class="logContentArea">
        <div class="tableBox">
          <border-table :tableData="logData" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
          <!-- <el-table v-if="total>0" class="logDataTable" :max-height="tableMaxHeight" :data="logData" stripe style="width: 100%;"> -->
            <!-- <el-table-column type="index" width="40"></el-table-column> -->
            <el-table-column prop="id" label="ID" width="80" sortable></el-table-column>
            <el-table-column prop="method" label="操作类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.method == 'add'" style="color:#409EFF">增加</span>
                <span v-else-if="scope.row.method == 'del'" style="color:#F56C6C">删除</span>
                <span v-else-if="scope.row.method == 'update'" style="color:#E6A23C">修改</span>
                <span v-else-if="scope.row.method == 'other'" style="color:#909399">其他</span>
              </template>
            </el-table-column>
            <el-table-column prop="content" label="操作内容" min-width="400"></el-table-column>
            <el-table-column prop="isTenant" label="是否租户操作">
              <template slot-scope="scope">{{scope.row.isTenant ? "是" : "否"}}</template>
            </el-table-column>
            <el-table-column prop="createNickName" label="操作人"></el-table-column>
            <el-table-column prop="ip" label="ip地址" min-width="130"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" min-width="170" sortable></el-table-column>
          <!-- </el-table> -->
          <!-- <div class="hasNoData" v-if="noData">
            <div class="noDataImg"><img src="../../../../static/img/noData.png" alt=""></div>
            <p>暂无数据</p>
          </div> -->
          </border-table>
        </div>
        <!-- <div class="pageBox" v-if="total>0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
var qs = require("qs");
import BorderTable from "@/components/common/BorderTable";
export default {
  components: {
    BorderTable,
  },
  data() {
    return {
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      noData: false,
      options: [
         {
          value: "add",
          label: "增加"
        },
        {
          value: "del",
          label: "删除"
        },
        {
          value: "update",
          label: "修改"
        },
        {
          value: "other",
          label: "其他"
        }
      ],
      logType: "",
      dateTimeRange: [],
      tableMaxHeight: 0,
      searchInput: "",
      logData: [],
      styleObject: {
        height: ""
      },
      content:'',
      ip:''
    };
  },
  created() {
    this.makeheight();
    this.queryLog();
    // if (this.getViewportSize.height > 768) {
    //   this.tableMaxHeight = this.getViewportSize.height - 290;
    // } else {
    //   this.tableMaxHeight = 486;
    // }
  },
  methods: {
    //查询租户功能
    searchLogs() {
      this.pagination.currentPage=1
      let dateTimeRange = this.dateTimeRange || [];
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    //刷新数据
    refreshData() {
      let dateTimeRange = this.dateTimeRange || [];
      this.pagination.currentPage = 1;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    getTime(date) {
      if (date) {
        let year = date.getFullYear(); //获取完整的年份(4位,1970-????)
        let month =
          date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        let datenow =
          date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取当前日(1-31)
        let day =
          date.getDay() == 0 ?
          "星期天" :
          date.getDay() == 1 ?
          "星期一" :
          date.getDay() == 2 ?
          "星期二" :
          date.getDay() == 3 ?
          "星期三" :
          date.getDay() == 4 ?
          "星期四" :
          date.getDay() == 5 ? "星期五" : "星期六"; //获取当前星期X(0-6,0代表星期天)
        let hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //获取当前小时数(0-23)
        let minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //获取当前分钟数(0-59)
        let seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //获取当前秒数(0-59)
        return (
          year +
          "-" +
          month +
          "-" +
          datenow +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      } else {
        return "";
      }
    },
    queryLog(operType, page, pageSize,content,ip) {
      this.loading = true;
      this.request.get("/front/system/log/query", {
          // params: {
            // startTime: startTime || "",
            // endTime: endTime || "",
            page: page || 1,
            pageSize: pageSize || 10,
            order: "desc",
            sort: "createTime",
            content:content||"",
            ip:ip||"",
            method:operType||""
          // }
        })
        .then(rs => {
          console.log(rs);
          
          this.loading = false;
          if (rs.code == 200) {
            this.logData = rs.data;
            this.pagination.total = rs.total;
            this.noData = false;
            if (!rs.total) {
              this.noData = true;
            }
          } else {
            this.noData = true;
          }
        });
    },
    handleSizeChange(val) {
      let dateTimeRange = this.dateTimeRange || [];
      this.pagination.pageSize = val;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        1,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    handleCurrentChange(val) {
      let dateTimeRange = this.dateTimeRange || [];
      this.pagination.currentPage = val;
      this.queryLog(
        this.logType,
        // this.getTime(dateTimeRange[0]),
        // this.getTime(dateTimeRange[1]),
        this.pagination.currentPage,
        this.pagination.pageSize,
        this.content,
        this.ip
      );
    },
    delLogs() {
      this.$confirm("此操作将删除一个月之前的所有日志, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.request.post("/front/system/log/clear/month-ago").then(rs => {
            if (rs.code == 200) {
              this.msg.success("日志删除成功");
              let dateTimeRange = this.dateTimeRange || [];
              this.queryLog(
                this.logType,
                // this.getTime(dateTimeRange[0]),
                // this.getTime(dateTimeRange[1]),
                1,
                this.pagination.pageSize,
                this.content,
                this.ip
              );
            } else {
              this.msg.error("删除失败，" + rs.msg);
            }
          });
        })
        .catch(() => {
          this.msg.info("已取消删除");
        });
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.logContainer {
  // height: 100%;
  // overflow: hidden;
  position: relative;

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  .logHandlerArea {
    margin-bottom: 20px;
    overflow: hidden;
    .selectForm {
      float: left;
      width:150px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .dateTimeRangePicker {
      float: left;
      width: 360px;
      height: 36px;
      vertical-align: middle;
      margin-right: 10px;
    }
    .scontent{
      float: left;
      height: 36px;
    }
    .primaryBtn {
      float: left;
      height: 36px;
      vertical-align: middle;
      margin-left: 0;
    }

    .delSome {
      float: right;
      height: 36px;
      vertical-align: middle;
      margin-left: 0;
      padding: 0 10px;
    }
  }

}
</style>
<style lang="scss">
.logContainer{
  .logHandlerArea {
    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width:150px;
      margin-right: 10px;

      .el-input {
        width:150px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
}
</style>

